(() => {
  'use strict';
  const script = document.currentScript;
  const more = script?.dataset.more || 'Read more';
  const less = script?.dataset.less || 'Show less';
  const compactCounts = script?.dataset.cardReviewCounts === 'true';
  let pending = false;
  function update() {
    pending = false;
    if (compactCounts) {
      document.querySelectorAll('product-card .jdgm-prev-badge__text').forEach(element => {
        const match = element.textContent.trim().match(/\d+/);
        if (!match) return;
        const value = '(' + match[0] + ')';
        if (element.textContent.trim() !== value) element.textContent = value;
      });
    }
    const widget = document.querySelector('.jdgm-cards-carousel');
    if (!widget) return;
    const section = widget.closest('[id^="shopify-section-"]');
    if (section && !section.querySelector('#mc-customer-reviews')) {
      const anchor = document.createElement('span');
      anchor.id = 'mc-customer-reviews';
      section.prepend(anchor);
    }
    const ratingNode = widget.querySelector('.jdgm-rating-text');
    const countNode = widget.querySelector('.jdgm-reviews-count');
    const match = ratingNode?.textContent?.match(/\d+[.,]\d+/);
    const rating = match ? Number(match[0].replace(',', '.')) : NaN;
    const count = Number(countNode?.textContent?.replace(/\D/g, ''));
    if (rating > 0 && rating <= 5 && count > 0) {
      const locale = document.documentElement.lang || 'de';
      const ratingText = new Intl.NumberFormat(locale, { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(rating);
      const countText = new Intl.NumberFormat(locale).format(count);
      document.querySelectorAll('[data-mc-review-summary]').forEach(summary => {
        const text = summary.querySelector('[data-mc-review-summary-text]');
        const value = summary.dataset.ratingTemplate.replace('__RATING__', ratingText).replace('__COUNT__', countText);
        if (text.textContent !== value) text.textContent = value;
        summary.style.setProperty('--mc-rating', `${rating / 5 * 100}%`);
        summary.hidden = false;
      });
    }
    widget.querySelectorAll('.jdgm-card').forEach(card => {
      if (card.closest('mc-reviews-block')) return;
      const text = card.querySelector('.jdgm-text');
      if (!text || card.querySelector('.mc-review-expand') || text.textContent.trim().length < 100) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mc-review-expand';
      button.textContent = more;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', event => {
        event.stopPropagation();
        const expanded = card.classList.toggle('mc-review-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? less : more;
      });
      text.after(button);
    });
  }
  const roots = new Set();
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  });
  function observeReviews() {
    for (const root of roots) {
      if (!root.isConnected) roots.delete(root);
    }
    const selector = compactCounts ? 'mc-reviews-block, product-card' : 'mc-reviews-block, .jdgm-cards-carousel';
    document.querySelectorAll(selector).forEach(root => roots.add(root));
    observer.disconnect();
    roots.forEach(root => observer.observe(root, { childList: true, subtree: true }));
    update();
  }
  observeReviews();
  document.addEventListener('shopify:section:load', observeReviews);
})();


(() => {
 const header = document.querySelector('header-component');
 if (!header) return;
 let queued = false;
 function syncLanguage() {
  queued = false;
  const fallback = header.querySelector('.mc-language-fallback');
  if (!fallback) return;
  const selector = header.querySelector('.ht-tms-selector');
  if (selector && selector.parentElement !== fallback.parentElement) fallback.before(selector);
  const languageSelect = fallback.querySelector('select[name="language_code"]');
  const names = new Map(Array.from(languageSelect?.options || []).map(option => [option.value, option.textContent.trim()]));
  const languageLabel = languageSelect?.getAttribute('aria-label') || 'Language';
  for (const item of header.querySelectorAll('.ht-tms-dropdown__selected,.ht-tms__duo-selector__active-item,.ht-tms-option__item')) {
   const name = names.get(item.dataset.value);
   if (!name) continue;
   const selected = item.matches('.ht-tms-dropdown__selected,.ht-tms__duo-selector__active-item');
   const label = selected ? languageLabel + ': ' + name : name;
   if (item.getAttribute('aria-label') !== label) item.setAttribute('aria-label', label);
   if (item.title !== label) item.title = label;
   const flag = item.querySelector('img.tms-element-flag');
   if (flag && flag.alt !== name) flag.alt = name;
  }
  const available = Array.from(header.querySelectorAll('.ht-tms-dropdown__selected,.ht-tms__duo-selector__active-item')).some(el => {
   const box = el.getBoundingClientRect();
   const style = getComputedStyle(el);
   return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  });
  if (fallback.hidden !== available) fallback.hidden = available;
 }
 function schedule() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(syncLanguage);
 }
 new MutationObserver(schedule).observe(header,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden']});
 window.addEventListener('resize',schedule);
 syncLanguage();
})();




(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-mc-cart-preview-url]');
    if (!button) return;
    event.preventDefault();
    window.open(button.dataset.mcCartPreviewUrl, '_blank', 'noopener');
  });
})();


if (!customElements.get('mc-unboxing-proof')) {
  customElements.define('mc-unboxing-proof', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.addEventListener('click', event => {
        if (this.dialog?.contains(event.target) || event.target === this.dialog) event.stopPropagation();
        if (event.target.closest('[data-mc-proof-open]')) this.openDialog();
        if (event.target.closest('[data-mc-proof-close]')) this.dialog?.close();
        const choice = event.target.closest('[data-mc-proof-select]');
        if (choice) this.selectVideo(choice.dataset.mcProofSelect);
        if (event.target === this.dialog) this.dialog.close();
      }, { signal });
    }
    openDialog() {
      if (!this.dialog) {
        const content = this.querySelector('template')?.content;
        if (!content) return;
        this.append(content.cloneNode(true));
        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }, { capture: true, signal: this.events.signal });
        this.dialog.addEventListener('close', () => {
          this.querySelectorAll('video').forEach(video => video.pause());
          document.documentElement.classList.remove('mc-proof-is-open');
          this.querySelector('[data-mc-proof-open]')?.focus();
        }, { signal: this.events.signal });
      }
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('mc-proof-is-open');
      this.selectVideo('0');
    }
    selectVideo(index) {
      document.querySelectorAll('mc-unboxings video, mc-unboxing-proof video').forEach(video => video.pause());
      this.querySelectorAll('[data-mc-proof-select]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.mcProofSelect === index));
      });
      this.querySelectorAll('[data-mc-proof-video]').forEach(video => {
        const active = video.dataset.mcProofVideo === index;
        video.hidden = !active;
        if (!active) return;
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.play().catch(() => {});
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.events?.abort();
    }
  });
}


(() => {
  const breakpoint = window.matchMedia('(max-width: 749px)');
  const setup = () => document.querySelectorAll('details.mc-mobile-disclosure').forEach(details => {
    if (details.dataset.mobileReady) return;
    details.dataset.mobileReady = 'true';
    details.open = !breakpoint.matches;
    breakpoint.addEventListener('change', () => { details.open = !breakpoint.matches; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
